// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".u-fs-16[data-v-033e2616]{font-size:16px}.mt-8[data-v-033e2616]{margin-top:32px}\n", "",{"version":3,"sources":["webpack://./src/js/components/pages/Posts.vue"],"names":[],"mappings":"AACA,0BACE,cAAe,CAChB,uBAEC,eAAgB","sourcesContent":["\n.u-fs-16 {\n  font-size: 16px;\n}\n.mt-8 {\n  margin-top: 32px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
